var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('PartnersHeader'),_c('PartnersIntro'),_vm._l((_vm.sections),function(section,index){return _c('PartnersIndex',{key:section.title,class:{ '-alt-top': index > 0 },attrs:{"section":section}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }